import type { FaireProductEntity } from "../../entity_types/product";

export const p_qp53amckwx: FaireProductEntity = {
  token: "p_qp53amckwx",
  type: "product",
  name: "Baby Mobile Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/29787243a81632ec8d09b8ecad464136eb5756e351dc29b43a42333efc4870e9.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/caedae97b91d54ecd51872087649d4d87c870cbf72e4a9ad7f18b60ad6f82e9e.png",
    "https://cdn.faire.com/fastly/cfe8da7f6c99ec8fe920566042dd04ee2c766c481973b1d425da5a4a4b2e744b.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:17.431Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
